import type { ReactNode } from 'react';
import { TextInput, Field } from '@hotjar/hotsauce';
import type { FieldError, useForm } from 'react-hook-form';
import styled from '@emotion/styled';
import type { FormInputs } from './InvoiceDetailsForm';

const S = {
  Field: styled(Field)`
    width: 100%;
  `,
  TextInput: styled(TextInput)`
    /* this is necessary for all fields to be the same width when they are next to each other */
    & input {
      width: 100%;
    }
  `,
};

interface FormFieldProps {
  t(key: string): string;
  register: ReturnType<typeof useForm>['register'];
  error: FieldError | undefined;
  fieldName: keyof FormInputs;
  isRequired?: boolean;
  type?: 'email' | 'text';
  children?: ReactNode;
  placeholder?: string;
  labelText: string;
  helperText?: string;
  maxLength?: number;
}

export function FormField({
  t,
  register,
  error,
  fieldName,
  isRequired = false,
  type,
  children,
  placeholder = ' ',
  labelText,
  helperText = ' ',
  maxLength,
}: FormFieldProps): JSX.Element {
  const id = fieldName;

  const props = type && {
    id,
    ref: register({ required: isRequired && t('error.required') }),
    name: fieldName,
    placeholder,
    isInvalid: !!error,
    maxLength,
  };

  return (
    <S.Field
      labelText={labelText}
      helperText={helperText}
      invalidText={error?.message}
      isInvalid={!!error}
      isRequired={isRequired}
      inputId={id}
    >
      {type === 'text' && <S.TextInput {...props} />}
      {children}
    </S.Field>
  );
}
